import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  rightSection: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
}));
